"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withRequestOnly = exports.withRequest = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * RequestProvider enables Express request chain params req and res to be exposed to nested React Components
 */
class RequestProvider extends _react.Component {
  getChildContext() {
    const {
      req,
      res
    } = this.props;
    return {
      req,
      res
    };
  }
  render() {
    return this.props.children;
  }
}
(0, _defineProperty2.default)(RequestProvider, "propTypes", {
  req: _propTypes.default.object.isRequired,
  res: _propTypes.default.object.isRequired
});
// you must specify what you’re adding to the context
(0, _defineProperty2.default)(RequestProvider, "childContextTypes", {
  req: _propTypes.default.object.isRequired,
  res: _propTypes.default.object.isRequired
});
var _default = exports.default = RequestProvider;
/**
 * Useage function, adds req and res as available props, as well as the direct res.locals which are commonly required
 */
const withRequest = ComponentToWrap => {
  var _RequestComponent;
  return _RequestComponent = class RequestComponent extends _react.Component {
    render() {
      const {
        res,
        req
      } = this.context;
      const {
        locals = {}
      } = typeof res !== 'undefined' ? res : {};
      return /*#__PURE__*/_react.default.createElement(ComponentToWrap, (0, _extends2.default)({
        req: req,
        res: res
      }, locals, this.props));
    }
  }, (0, _defineProperty2.default)(_RequestComponent, "contextTypes", {
    req: _propTypes.default.object.isRequired,
    res: _propTypes.default.object.isRequired
  }), _RequestComponent;
};

/**
 * Useage function, adds req and res as available props without the locals
 */
exports.withRequest = withRequest;
const withRequestOnly = ComponentToWrap => {
  var _RequestComponent2;
  return _RequestComponent2 = class RequestComponent extends _react.Component {
    render() {
      const {
        res,
        req
      } = this.context;
      return /*#__PURE__*/_react.default.createElement(ComponentToWrap, (0, _extends2.default)({
        req: req,
        res: res
      }, this.props));
    }
  }, (0, _defineProperty2.default)(_RequestComponent2, "contextTypes", {
    req: _propTypes.default.object.isRequired,
    res: _propTypes.default.object.isRequired
  }), _RequestComponent2;
};
exports.withRequestOnly = withRequestOnly;